import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SingleTableModel } from '../../models/singleTableModel';
import { TenantsService } from '../../services/tenants.service';
import { Router } from '@angular/router';
import { ErrorService } from '../../services/error.service';
import { action } from '../../util/enums'

@Component({
  selector: '[apptenantDetails]',
  templateUrl: './tenantDetails.component.html',
  styleUrls: ['./tenantDetails.component.css'],
  standalone: false
})
export class TenantDetailsComponent {
  @Input() tenant!: SingleTableModel;
  @Input() isAdminUser!: boolean;
  @Input() action!: string;
  @Output() postActionEvent = new EventEmitter<string>();
  actionHappening: action = action.nothing;
  isLoading: boolean = false;
  initialTenant = new SingleTableModel('', '', '', '', true, 'tenant', '', '', '', '', '', 0, '', '', '', localStorage.getItem('UserName') ?? '','');
  displayStyle: string = "none";
  entityName: string = '';
  isActiveCssClass = 'form-check form-switch'

  constructor(private tenantsService: TenantsService,  private router: Router, private errorService: ErrorService) {

  }

  updateAction(action: string) {
    this.action = action;
    if (this.action == 'update') {
      this.initialTenant.name = this.tenant.name;
      this.initialTenant.email = this.tenant.email;
    }
  }

  disableTenant(updatedAction: string) {
    this.isActiveCssClass = 'spinner-border spinner-border-sm';
    this.actionHappening = action.disable;
    this.isLoading = true;
    this.tenantsService.disableTenant(this.tenant).subscribe((updatedTenant) => {
      this.action = updatedAction;
      alert(updatedTenant.message);
      this.postAction('refresh');
    },
      (error) => {
        this.errorService.alertError(error);
        this.postAction('refresh');
      }
    )
  }

  openConfirmationDialog() {
    this.actionHappening = action.delete;
    this.entityName = this.tenant.id;
    this.displayStyle = 'block';
  }

  confirmDelete(isConfirmed: boolean) {
    if (isConfirmed) {
      this.deleteTenant('view');
    }
    else {
      this.actionHappening = action.nothing;
    }
  }

  deleteTenant(updatedAction: string) {
    if (this.tenant.isActive) {
      alert('An active tenant cannot be deleted');
      return;
    }
    this.actionHappening = action.delete;
    this.isLoading = true;
    this.tenantsService.deleteTenant(this.tenant.accessKey, this.tenant.id).subscribe((updatedTenant) => {
      this.action = updatedAction;
      alert(updatedTenant.message);
      this.postAction('refresh');
    },
      (error) => {
        this.errorService.alertError(error);
        this.postAction('refresh');
      }
    )
  }


 cancelEdit(updatedAction: string) {
    this.tenant.name = this.initialTenant?.name || '';
    this.tenant.email = this.initialTenant?.email || '';
    this.updateAction(updatedAction);
  }

  cancelCreate(updatedAction: string) {
    this.initialTenant.email = '';
    this.initialTenant.name = '';
    this.initialTenant.id = '';
    this.tenant.email = '';
    this.tenant.name = '';
    this.tenant.id = '';
    this.postAction('reload');
  }

  billinDets() {
    this.router.navigate(['/billing'], { queryParams: { tenantId: this.tenant.id, accessKey: this.tenant.accessKey } });
  }

 createTenant(updatedAction: string) {
    this.actionHappening = action.create;
    this.isLoading = true;
    this.tenantsService.createTenant(this.tenant).subscribe((createdTenant) => {
      this.action = updatedAction;
      if (createdTenant.message != undefined) {
        alert(createdTenant.message);
      }
      else {
        alert('Tenant created successfully with Tenant id ' + createdTenant.id + ' and AccessKey ' + createdTenant.accessKey);
      }
      this.postAction('refresh');
    },
      (error) => {
        this.errorService.alertError(error);
        this.actionHappening = action.nothing;
        this.isLoading = false;
      }
    )
  }

  updateTenant(updatedAction: string) {
    var tenantNameRegex = new RegExp(/^[a-zA-Z0-9 ]{1,50}$/)
    var emailRegex = new RegExp(/^[A-Za-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{1,4}[^\\S]+$/);
    if (!tenantNameRegex.test(this.tenant.name) || this.tenant.name.length > 50 || this.tenant.name.length < 1) {
      alert('Please enter valid tenant name');
      return;
    }
    if (this.tenant.email != '') {
      if (!(emailRegex.test(this.tenant.email) || this.tenant.email.length > 70)) {
        alert('Please enter valid tenant email');
        return;
      }
    }
    this.actionHappening = action.update;
    this.isLoading = true;
    this.tenantsService.updateTenant(this.tenant).subscribe((updatedTenant) => {
      this.action = updatedAction;
      if (updatedTenant.message != undefined)
        alert(updatedTenant.message);
      else
        alert('Tenant created successfully with Tenant id ' + updatedTenant.tenantId + ' and AccessKey ' + updatedTenant.accessKey);
      this.postAction('refresh');
    },
      (error) => {
        this.errorService.alertError(error);
        this.postAction('refresh');
      }
    )
  }
  saveTenant(updatedAction: string) {
    if (this.action == 'view') {
      this.initialTenant = this.tenant;
      this.action = updatedAction;
    }
  }

  postAction(value: string) {
    this.postActionEvent.emit(value);
  }
}
